import { render } from "./QuestionTypeTable.vue?vue&type=template&id=ee9d82ce&scoped=true"
import script from "./QuestionTypeTable.vue?vue&type=script&lang=js"
export * from "./QuestionTypeTable.vue?vue&type=script&lang=js"

import "./QuestionTypeTable.vue?vue&type=style&index=0&id=ee9d82ce&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9d82ce"]])

export default __exports__